<script setup lang="ts">
defineProps<{
  title: string
}>()
</script>

<template>
  <div class="mb-4 flex items-center gap-2">
    <span class="h-2 w-2 shrink-0 rounded-full bg-[#2d5396]" />
    <h2 class="text-[#1b325a] text-[22px] font-semibold">{{ title }}</h2>
    <slot />
  </div>
</template>
